export enum SignUpStepType {
  CHOOSE_PASSWORD = 'CHOOSE_PASSWORD',
  LOCATION_DETAILS = 'LOCATION_DETAILS',
  PERSONAL_DETAILS = 'PERSONAL_DETAILS',
  PROFILE_DETAILS = 'PROFILE_DETAILS',
  SIGNUP_COMPLETE = 'SIGNUP_COMPLETE'
}
